import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Small prompt dialog asking the admin for the new email address. Resolves with the
 * trimmed string when accepted, or <code>undefined</code> when cancelled.
 *
 * Pre-validation is deliberately minimal — server is the authority on availability and
 * the wider format check runs afterward. We only block empty input here. Clearing an email
 * to null is intentionally NOT offered — certain roles (e.g. PrincipalAccountAdmin) require
 * an email for login/password-reset flows, so leaving it null is unsafe.
 */
@Component({
  selector: 'prox-change-email-prompt-dialog',
  standalone: false,
  template: `
    <div class="space-y-3">
      <div class="text-sm">
        Change email for <span class="font-semibold">{{ currentDisplay }}</span>:
      </div>
      <div>
        <input
          type="email"
          pInputText
          [(ngModel)]="newEmail"
          (keyup.enter)="ok()"
          autocomplete="off"
          class="w-full"
          placeholder="new.email@company.com"
          autofocus
        />
      </div>
      <div class="mt-3 flex justify-end gap-2">
        <button
          (click)="ok()"
          [disabled]="!newEmail || !newEmail.trim()"
          pButton
          type="button"
          icon="pi pi-check"
          label="OK"
          class="p-button-raised p-button-primary"
        ></button>
        <button
          (click)="cancel()"
          pButton
          type="button"
          icon="pi pi-times"
          label="Cancel"
          class="p-button-raised p-button-secondary"
        ></button>
      </div>
    </div>
  `,
})
export class ChangeEmailPromptDialogComponent {
  newEmail = '';
  currentDisplay = '';

  constructor(
    dialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
  ) {
    const data = dialogConfig.data ?? {};
    this.currentDisplay = data.currentDisplay ?? '';
  }

  ok() {
    const v = (this.newEmail ?? '').trim();
    if (!v) return;
    this.ref.close(v);
  }

  cancel() {
    this.ref.close(undefined);
  }
}
